/**
 * ResponsiveTable
 */
import * as React from 'react';

// Styles
import './styles.scss';

interface Props {
    children?: React.Node;
    style?: Record<string, any>;
}

export default class ResponsiveTable extends React.PureComponent<Props> {
    render() {
        const { children, style } = this.props;
        if (!children) return null;
        return (
            <span className="responsive-table" style={style}>
                {children}
            </span>
        );
    }
}
